import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import HowItWorks from './components/HowItWorks';
import WhyUs from './components/WhyUs';
import AppPreview from './components/AppPreview';
import Mission from './components/Mission';
import CTA from './components/CTA';
import Footer from './components/Footer';
import MobileBottomNav from './components/MobileBottomNav';

function App() {
  return (
    <div className="min-h-screen bg-background font-body">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <SolutionSection />
        <HowItWorks />
        <WhyUs />
        <AppPreview />
        <Mission />
        <CTA />
      </main>
      <Footer />
      {/* Bottom padding on mobile so footer isn't hidden behind bottom nav */}
      <div className="h-20 md:hidden"></div>
      <MobileBottomNav />
    </div>
  );
}

export default App;
